import FeatureSection from './feature-section';

export default FeatureSection;
